import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TextShort',
    props: {
        text: {
            type: String,
            required: true,
        },
        maxLength: {
            type: Number,
            default: 24,
        },
    },
    setup(__props) {
        const props = __props;
        const text = computed(() => {
            if (props.text.length > props.maxLength) {
                const partialText = props.text.slice(0, props.maxLength);
                return `${partialText}...`;
            }
            else {
                return props.text;
            }
        });
        return { __sfc: true, props, text };
    }
});
